<template>
  <router-link :class="[isFolder ? 'folder' : 'file']"
               tag="li" :to="menu.link" exact>
    <label :class="{'open': open}" @click="toggle($event)">
      {{ menu.caption }}
    </label>
    <transition name="dropdown">
      <ul v-show="open">
        <item
          v-for="(legacy, index) in menu.children"
          :key="index"
          :menu="legacy">
        </item>
      </ul>
    </transition>
  </router-link>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'item',
  props: ['menu'],
  data: function () {
    return {
      open: true
    }
  },
  computed: {
    isFolder () {
      return this.menu.children && this.menu.children.length
    },
    ...mapState({})
  },
  methods: {
    ...mapMutations({}),
    toggle (event) {
      if (this.isFolder) {
        event.preventDefault()
        this.open = !this.open
      }
    }
  }
}
</script>

<style scoped>
  ul {
    padding-left: 0px;
    line-height: 1.5em;
    list-style-type: none;
    background: #78909c;
  }

  .dropdown-enter-active {
    transition: max-height 1s, opacity 1.4s;
    max-height: 120px;
    opacity: 1;

  }

  .dropdown-leave-active {
    opacity: 0.8;
    transition: max-height 0.8s;
    max-height: 120px;
  }

  .dropdown-enter,
  .dropdown-leave-to {
    opacity: 0;
    max-height: 0px;
  }

  .dropdown-leave {
    opacity: 0;
    max-height: 120px;

  }

  li.file.router-link-exact-active.router-link-active > label {
    color: #37474F;
    background: #fff;
    border-left: #16a34a solid 6px;
    padding-left: 44px;
  }

  label {
    font-family: "PT Root UI Medium", Tahoma, Geneva, Verdana, sans-serif !important;
    display: block !important;
    margin: 0px;
    padding: 20px 0px 20px 24px;
    color: #F5F7F8;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 20px;
    text-transform: uppercase;
    cursor: pointer;
  }

  label:hover {
    background: rgba(207, 216, 220, 0.75);
  }

  .cd-accordion-menu li.file > label {
    text-transform: none;
  }

  .cd-accordion-menu li.file > label {
    /*content: "\0020";*/
    /*font-family: 'Font Awesome\ 5 Free';*/
    /*font-weight: 900;*/
    /*transform: translateY(0%) translateX(0%);*/
    padding-left: 50px;
  }

  @media screen
  and (min-width: 1024px)
  and (max-width: 1439px) {
    .cd-accordion-menu li.file > label {
      padding-right: 10px;
    }
  }

  .cd-accordion-menu li.folder > label::before {
    width: 20px;
    height: 20px;
    content: "\f054";
    font-family: 'Font Awesome\ 5 Free';
    font-weight: 900;
    margin-right: 11.5px;
  }

  .cd-accordion-menu li.folder > label.open::before {
    margin-right: 2px;
  }

  .cd-accordion-menu label.open::before {
    display: inline-block;
    -webkit-transform: rotate(90deg) translateX(20%);
    -moz-transform: rotate(90deg) translateX(20%);
    -o-transform: rotate(90deg) translateX(20%);
    -ms-transform: rotate(90deg) translateX(20%);
    transform: rotate(90deg) translateX(20%);
    transition: transform 0.3s;

  }

</style>
